export default __webpack_public_path__ + "static/media/git.a63f9eab.svg";